/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";

import {
  StyledHelperText,
  StyledInput,
  StyledLabel,
  StyledRequired,
  StyledSpacer14,
} from "../superAdmin/catalog/lib/styles";
import { redesignTheme } from "../theme/theme";

type TextInputFieldPropTypes = {
  disabled?: boolean;
  handleChange: (event) => void;
  helperText?: string;
  id: string;
  isRequired?: boolean;
  label?: string;
  placeholderText?: string;
  value: string;
};

const TextInputField = ({
  disabled,
  handleChange,
  helperText,
  id,
  isRequired,
  label,
  placeholderText,
  value,
}: TextInputFieldPropTypes): React.ReactElement => {
  return (
    <>
      {label && (
        <StyledLabel htmlFor={id}>
          {label}
          {isRequired && <StyledRequired>*</StyledRequired>}
        </StyledLabel>
      )}
      <StyledInput
        data-testid={id}
        disabled={disabled}
        style={{
          cursor: disabled ? "not-allowed" : "text",
          color: disabled
            ? redesignTheme.color.gray500
            : redesignTheme.color.gray900,
        }}
        id={id}
        name={id}
        onChange={handleChange}
        placeholder={placeholderText}
        type="text"
        value={value}
      />
      {helperText && (
        <>
          <StyledSpacer14 />
          <StyledHelperText>{helperText}</StyledHelperText>
        </>
      )}
    </>
  );
};

TextInputField.defaultProps = {
  label: "",
  helperText: "",
  isRequired: false,
  placeholderText: "",
};

export default TextInputField;
